import i18n from "../../../i18n"
import {
  getAreaMonitoringReport,
  getDayOverviewReport,
  getEmissionsReport,
  getFuelPurchasesReport,
  getIdleStopsReport,
  getMaintenanceReport,
  getSpeedViolationReport,
  getTachographReport,
  getTagReport,
  getTemperatureQualityMonitoringReport,
  getTemperatureQualityReport,
  getTemperatureReport,
  getVehicleDistanceReport,
  getVehicleReport,
  getWeeklyWorkingHoursReport
} from "../../../services/calls/reports"
import { REP_COLS } from "./columnData"

export const REPORTS = {
  'mobile-list': {
    name: i18n.t('Mobile list'),
    url: '/mobile-list',
    filters: ['fleet', 'mobiles'],
    funcFilters: {
      mobiles: 'mobileids',
    },
    getFunction: getVehicleReport,
    hasTable: true,
    hasGraph: false,
    rowId: 'globalid',
    permissions: [{ name: 'trackwell.cs_report_mobilelist', inverted: true }],
    columns: [
      REP_COLS.REGISTRY_NUMBER, REP_COLS.GLOBALID, REP_COLS.MOBILE_DESCR, REP_COLS.ODOMETER,
      REP_COLS.WORKING_HOURS, REP_COLS.DRIVER
    ]
  },
  'idle-stops': {
    name: i18n.t('Idle stops'),
    url: '/idle-stops',
    filters: ['fleet', 'mobiles', 'date'],
    funcFilters: {
      mobiles: 'mobileids',
      date: 'date',
    },
    getFunction: getIdleStopsReport,
    hasTable: true,
    hasGraph: false,
    hasExpandRow: true,
    rowId: 'globalid',
    permissions: [{ name: 'trackwell.cs_report_idlestops', inverted: true }],
    columns: [
      REP_COLS.GLOBALID, REP_COLS.PERIOD, REP_COLS.TOTAL_IDLE_TIME, REP_COLS.STOP_COUNT, REP_COLS.AVG_IDLE_DURATION
    ]
  },
  'tachograph': {
    name: i18n.t('Tachograph'),
    url: '/tachograph',
    filters: ['fleet', 'mobiles', 'filetype', 'daterange'],
    funcFilters: {
      mobiles: 'mobileids',
      dates: {
        from: 'from_date',
        to: 'to_date',
      },
      filetype: 'mobile_or_driver'
    },
    getFunction: getTachographReport,
    hasTable: true,
    hasGraph: false,
    rowId: 'globalid',
    permissions: [{ name: 'trackwell.cs_report_tachograph', inverted: true }],
    columns: [
      REP_COLS.VEHICLE, REP_COLS.CREATE_DATE, REP_COLS.FILE_TYPE, REP_COLS.FILE
    ]
  },
  'tags': {
    name: i18n.t('Tags'),
    url: '/tags',
    filters: ['fleet', 'mobiles', 'daterange'],
    funcFilters: {
      mobiles: 'mobileids',
      dates: {
        from: 'from_date',
        to: 'to_date',
      }
    },
    getFunction: getTagReport,
    hasTable: true,
    hasGraph: false,
    rowId: 'globalid',
    permissions: [],
    columns: [
      REP_COLS.VEHICLE, REP_COLS.TIME, REP_COLS.LOCATION, REP_COLS.RADIUS, REP_COLS.SIGNAL_STRENGTH
    ]
  },
  'day-overview': {
    name: i18n.t('Day overview'),
    url: '/day-overview',
    filters: ['fleet', 'mobiles', 'daterange'],
    funcFilters: {
      mobiles: 'mobileids',
      dates: {
        from: 'from_date',
        to: 'to_date',
      }
    },
    getFunction: getDayOverviewReport,
    hasTable: true,
    hasGraph: false,
    rowId: 'globalid',
    permissions: [{ name: 'trackwell.cs_report_dayoverview', inverted: true }],
    columns: [
      REP_COLS.DATE, REP_COLS.VEHICLE, REP_COLS.STARTED_WORKING, REP_COLS.STOPPED_WORKING, REP_COLS.DISTANCE,
      REP_COLS.TOTAL_STOP_TIME, REP_COLS.TOTAL_IDLE_TIME, REP_COLS.DRIVING_TIME, REP_COLS. MAX_SPEED_OVER_LIMIT,
      REP_COLS.RESPONSIBLE, REP_COLS.SPEEDING
    ]
  },
  'weekly-hours': {
    name: i18n.t('Weekly working hours'),
    url: '/weekly-hours',
    filters: ['fleet', 'mobiles', 'date'],
    funcFilters: {
      mobiles: 'mobileids',
      date: 'date',
    },
    getFunction: getWeeklyWorkingHoursReport,
    hasTable: true,
    hasGraph: false,
    hasExpandRow: true,
    rowId: 'globalid',
    permissions: [{ name: 'trackwell.cs_report_weeklyhours', inverted: true }],
    columns: [
      REP_COLS.VEHICLE, REP_COLS.PERIOD, REP_COLS.TOTAL_HOURS
    ]
  },
  'fuel-purchases': {
    name: i18n.t('Fuel purchases'),
    url: '/fuel-purchases',
    filters: ['fleet', 'mobiles', 'daterange'],
    funcFilters: {
      mobiles: 'mobileids',
      dates: {
        from: 'from_date',
        to: 'to_date',
      }
    },
    getFunction: getFuelPurchasesReport,
    hasTable: true,
    hasGraph: false,
    rowId: 'globalid',
    permissions: [{ name: 'trackwell.cs_report_fuelpurchases', inverted: true }],
    columns: [
      REP_COLS.VEHICLE, REP_COLS.TRANSACTION_ID, REP_COLS.PURCHASE_DATE, REP_COLS.SITE_NAME, REP_COLS.FUEL_TYPE,
      REP_COLS.VOLUME, REP_COLS.AVERAGE_FUEL_CONSUMPTION, REP_COLS.DEVIATION_RECORDED
    ]
  },
  'emissions': {
    name: i18n.t('CO2 emissions'),
    url: '/emissions',
    filters: ['fleet', 'mobiles', 'daterange'],
    funcFilters: {
      mobiles: 'mobileids',
      dates: {
        from: 'from_date',
        to: 'to_date',
      }
    },
    getFunction: getEmissionsReport,
    hasTable: true,
    hasGraph: false,
    rowId: 'globalid',
    permissions: [],
    columns: [
      REP_COLS.REGISTRY_NUMBER, REP_COLS.GLOBALID, REP_COLS.TOTAL_DISTANCE, REP_COLS.TOTAL_EMISSIONS
    ]
  },
  'temperature': {
    name: i18n.t('Temperature overview'),
    url: '/temperature',
    filters: ['fleet', 'mobiles', 'daterange'],
    funcFilters: {
      mobiles: 'mobileids',
      dates: {
        from: 'from_date',
        to: 'to_date',
      }
    },
    getFunction: getTemperatureReport,
    hasTable: false,
    hasGraph: true,
    permissions: [{ name: 'trackwell.cs_report_temperature', inverted: true }],
    graph: {
      title: i18n.t('Temperature measurements'),
      subtitle: 'description',
      axis: {
        x: {
          type: 'datetime',
          title: i18n.t('Date')
        },
        y: {
          type: 'number',
          title: i18n.t('Temperature (˚C)')
        }
      },
      tooltip: '˚C',
      sortby: 'datadate',
      dataValue: 'temperature',
      min: 'lower_limit',
      max: 'upper_limit',
      yMin: -20,
      yMax: 30
    },
    seriesPath: 'sensordata'
  },
  'area-monitoring': {
    name: i18n.t('Area monitoring'),
    url: '/area-monitoring',
    filters: ['fleet', 'mobiles', 'daterange', 'visitedareas', 'areas'],
    funcFilters: {
      mobiles: 'mobileids',
      dates: {
        from: 'from_date',
        to: 'to_date',
      },
      visitedareas: 'visited',
      areas: 'areaids'
    },
    getFunction: getAreaMonitoringReport,
    hasTable: true,
    hasGraph: false,
    permissions: [{ name: 'trackwell.cs_report_areamonitoring', inverted: true }],
    columns: [
      REP_COLS.VEHICLE, REP_COLS.DATE_FROM, REP_COLS.DATE_TO, REP_COLS.AREA, REP_COLS.DURATION
    ]
  },
  'speed-violations': {
    name: i18n.t('Speed violations'),
    url: '/speed-violations',
    filters: ['fleet', 'mobiles', 'overlimit', 'daterange'],
    funcFilters: {
      mobiles: 'mobileids',
      dates: {
        from: 'from_date',
        to: 'to_date',
      },
      overlimit: 'minover'
    },
    getFunction: getSpeedViolationReport,
    hasTable: true,
    hasGraph: false,
    rowId: 'globalid',
    permissions: [{ name: 'trackwell.cs_report_speedviolations', inverted: true }],
    columns: [
      REP_COLS.VEHICLE, REP_COLS.TIME, REP_COLS.LOCATION, REP_COLS.SPEEDLIMIT, REP_COLS.SPEED
    ]
  },
  'temperature-quality-monitoring': {
    name: i18n.t('Temperature quality monitoring'),
    url: '/temperature-quality-monitoring',
    filters: ['fleet', 'mobiles', 'weekrange'],
    funcFilters: {
      mobiles: 'mobileids',
      weekrange: {
        from: 'from_date',
        to: 'to_date',
      }
    },
    getFunction: getTemperatureQualityMonitoringReport,
    hasTable: false,
    hasGraph: true,
    permissions: [{ name: 'trackwell.cs_report_temperature_quality_mon_form', inverted: true }],
    graph: {
      title: i18n.t('Temperature measurements'),
      subtitle: 'description',
      axis: {
        x: {
          type: 'datetime',
          title: i18n.t('Date')
        },
        y: {
          type: 'number',
          title: i18n.t('Temperature (˚C)')
        }
      },
      tooltip: '˚C',
      sortby: 'datadate',
      dataValue: 'temperature',
      min: 'lower_limit',
      max: 'upper_limit',
      yMin: -20,
      yMax: 30
    },
    seriesPath: 'sensordata'
  },
  'temperature-quality': {
    name: i18n.t('Temperature quality'),
    url: '/temperature-quality',
    filters: ['fleet', 'mobiles', 'weekrange'],
    funcFilters: {
      mobiles: 'mobileids',
      weekrange: {
        from: 'from_date',
        to: 'to_date',
      }
    },
    getFunction: getTemperatureQualityReport,
    hasTable: true,
    hasGraph: false,
    rowId: 'globalid',
    permissions: [{ name: 'trackwell.cs_report_temperature_quality_mon_report', inverted: true }],
    columns: [
      REP_COLS.NAME, REP_COLS.CHECKED_FROM, REP_COLS.CHECKED_TO, REP_COLS.APPROVED, REP_COLS.COMMENT,
      REP_COLS.USER, REP_COLS.LAST_MODIFIED
    ]
  },
  'maintenance': {
    name: i18n.t('Maintenance'),
    url: '/maintenance',
    filters: ['fleet', 'mobiles', 'daterange'],
    funcFilters: {
      mobiles: 'mobileids',
      dates: {
        from: 'from_date',
        to: 'to_date',
      }
    },
    getFunction: getMaintenanceReport,
    hasTable: true,
    hasGraph: false,
    rowId: 'globalid',
    permissions: [],
    columns: [
      REP_COLS.VEHICLE, REP_COLS.SERVICE, REP_COLS.DESCRIPTION, REP_COLS.SERVICE_TYPE,
      REP_COLS.PLANNED_AT, REP_COLS.SERVICED_AT, REP_COLS.DATE, REP_COLS.COST, REP_COLS.MESSAGE,
      REP_COLS.COMMENT
    ]
  },
  'vehicle-distance': {
    name: i18n.t('Vehicle distance'),
    url: '/vehicle-distance',
    filters: ['fleet', 'mobiles', 'date'],
    funcFilters: {
      mobiles: 'mobileids',
      date: 'date',
    },
    getFunction: getVehicleDistanceReport,
    hasTable: true,
    hasGraph: false,
    hasExpandRow: true,
    rowId: 'globalid',
    permissions: [{ name: 'trackwell.cs_report_vehicle_distance', inverted: true }],
    columns: [
      REP_COLS.GLOBALID, REP_COLS.PERIOD_DISTANCE, REP_COLS.TOTAL
    ]
  }
}